import React, { Component } from "react";
import Modal from "react-modal";
import firebase from "firebase";
import Alert from "react-s-alert";
import * as XLSX from "xlsx";
import "./modal.css";
import secondaryApp from "../BD/secondaryApp";
import store from "../../store";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { bool } from "prop-types";
const database = firebase.database();

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "1200px",
    height: "600px",
  },
};

class Modal_Upload_Data extends Component {
  constructor(props) {
    super(props);
    this.state = {
      uploadValue: 0,
      empleados: [],
      progreso: 0, // Porcentaje de progreso (0% a 100%)
      cargando: false,
      messages: [], // Indica si se está realizando la carga // Almacena los datos del Excel
      registrosProcesados: 0,
      registrosGuardados: 0,
      registrosConError: 0,
      mostrarErrores: false,
      showResumen: false,
      noErrors: false,
    };

    this.handleFileUpload = this.handleFileUpload.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.clientesRef = database.ref().child("Clientes");
    this.costosRef = database.ref().child("CentroCosto");
    this.limpiar = this.limpiar.bind(this);
    this.limpieza = this.limpieza.bind(this);
    this.resetUpload = this.resetUpload.bind(this);
  }

  componentWillMount() {
    Modal.setAppElement("body");
  }

  // Leer el archivo Excel y convertirlo a JSON
  handleFileUpload(event) {
    const file = event.target.files[0];

    if (!file) return;

    const validExtensions = [
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/vnd.ms-excel",
    ];

    if (!validExtensions.includes(file.type)) {
      alert("Solo se permiten archivos Excel (.xls, .xlsx)");
      event.target.value = "";
      return;
    }

    const reader = new FileReader();
    reader.readAsArrayBuffer(file);

    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });

      if (workbook.SheetNames.length === 1) {
        // Si solo tiene una hoja, procesarla directamente
        const sheet = workbook.Sheets[workbook.SheetNames[0]];
        const empleadosJSON = XLSX.utils.sheet_to_json(sheet);

        // En este caso, asumimos que los datos no tienen IDs separados
        this.setState({ empleados: empleadosJSON });
        console.log("Datos del Excel (hoja única):", empleadosJSON);
      } else {
        const empeladosSheet = workbook.Sheets["Empleados"]; // Tomar la primera hoja (Empleados)
        const idsSheet = workbook.Sheets["IDs"]; // Tomar la segunda hoja (IDs)

        console.log("SHEET S1 => ", idsSheet);

        if (!empeladosSheet || !idsSheet) {
          console.error("La hoja de IDs no existe");
          alert("El archivo no tiene formato esperado");
          return;
        }

        const empleadosJSON = XLSX.utils.sheet_to_json(empeladosSheet); // Convertir a JSON
        const idsJSON = XLSX.utils
          .sheet_to_json(idsSheet, { header: 1 })
          .flat(); // Convertir IDs a JSON y aplanar

        console.log("JSON SHEET S3 => ", idsJSON);
        // Añadir el _ID a cada empleado
        const empleadosConID = empleadosJSON.map((empleado, index) => ({
          _ID: idsJSON[index],
          ...empleado,
        }));
        this.setState({ empleados: empleadosConID });
        console.log("Datos del Excel:", empleadosConID);
      }
    };
  }

  // Guardar los datos en Firebase Realtime Database
  handleSubmit = async (event) => {
    event.preventDefault();
    const totalEmpleados = this.state.empleados.length;

    let messages = [];
    this.resetUpload();
    let noErrors = false;
    let empleadosProcesados = 0;
    let registrosGuardados = 0;
    let registrosConError = 0;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (this.state.empleados.length === 0) {
      this.state.messages.push({ detalle: "No hay datos para cargar" });
      return;
    }

    try {
      this.setState({ cargando: true });
      // Array para almacenar todas las promesas (creación o actualización de usuarios)
      const promesas = this.state.empleados.map(async (empleado) => {
        try {
          if (!empleado._ID) {
            // Si el _ID está vacío, creamos un nuevo usuario
            const user = await secondaryApp
              .auth()
              .createUserWithEmailAndPassword(
                empleado.correo,
                empleado.password
              );

            // Validar si el código de centro de costo existe
            const snapshot = await this.costosRef
              .orderByChild("codigo")
              .equalTo(empleado.codigo_centro_costo)
              .once("value");

            if (!snapshot.exists()) {
              registrosConError++;
              return {
                error: Object.assign(new Error(messages.detalle), {
                  code: "codigo_centro_costo",
                }),
                empleado,
              };
            }

            let codCosto = "";
            snapshot.forEach((childSnapshot) => {
              codCosto = childSnapshot.key; // Obtiene el UID del centro de costos
            });

            // Guardamos el nuevo empleado en la base de datos con el UID generado
            await this.clientesRef.child(user.uid).set({
              apellido: empleado.apellido,
              nombre: empleado.nombre,
              correo: empleado.correo,
              numero_empleado: empleado.numero_empleado,
              pasaporte: empleado.pasaporte,
              dui: empleado.dui,
              centro: codCosto,
              estado: "Activo",
              socio: this.props.socio,
              subir: false,
              viaje: "desactivo",
              viajeActual: "ninguno",
              preferencia: "Taxi",
              areaDesc: empleado.areaDesc,
              latitud: -89.20134488794466,
              longitud: 13.701950380252162,
            });
            registrosGuardados++;
            const nuevoProgreso = (empleadosProcesados / totalEmpleados) * 100;
            this.setState({ progreso: nuevoProgreso });
          } else {
            // Si el _ID existe, actualizamos el usuario en la base de datos
            const empleadoRef = this.clientesRef.child(empleado._ID);
            const snapshot = await empleadoRef.once("value");

            const ccosto = await this.costosRef
              .orderByChild("codigo")
              .equalTo(empleado.codigo_centro_costo)
              .once("value");

            if (!ccosto.exists()) {
              registrosConError++;

              return {
                error: Object.assign(new Error(messages.detalle), {
                  code: "codigo_centro_costo",
                }),
                empleado,
              };
            }

            if (!snapshot.exists()) {
              registrosConError++;
              return {
                error: Object.assign(new Error(messages.detalle), {
                  code: "_ID",
                }),
                empleado,
              };
            }

            if (!emailRegex.test(empleado.correo)) {
              registrosConError++;
              return {
                error: Object.assign(new Error(messages.detalle), {
                  code: "correo",
                }),
                empleado,
              };
            }
            // Actualizar los datos del empleado
            await empleadoRef.update({
              apellido: empleado.apellido,
              nombre: empleado.nombre,
              correo: empleado.correo,
              numero_empleado: empleado.numero_empleado,
              pasaporte: empleado.pasaporte,
              dui: empleado.dui,
              centro: empleado.codigo_centro_costo,
              areaDesc: empleado.areaDesc,
            });
            registrosGuardados++;
          }

          empleadosProcesados++;
          const nuevoProgreso = (empleadosProcesados / totalEmpleados) * 100;
          this.setState({ progreso: nuevoProgreso });

          return null; // Indica que no hubo error
        } catch (error) {
          registrosConError++;
          return { error, empleado };
        }
      });

      // Esperamos a que todas las promesas se resuelvan
      const results = await Promise.all(promesas);

      // Filtramos los errores
      const errores = results.filter((result) => result && result.error);

      if (errores.length > 0) {
        let campo = "";
        let valor = "";
        let detalle = "";
        errores.forEach(({ error, empleado }) => {
          //mensajeError += `- Empleado ${empleado.nombre} ${empleado.apellido}: `;
          console.log("ERROR in forEach => ", error.message);

          if (error.code === "auth/email-already-in-use") {
            detalle = "El correo ya está en uso.";
            campo = "correo";
            valor = empleado.correo;
          } else if (error.code === "auth/invalid-email") {
            detalle = "Correo electrónico no válido.";
            campo = "correo";
            valor = empleado.correo;
          } else if (error.code === "auth/weak-password") {
            detalle = "Contraseña demasiado débil.";
            campo = "contraseña";
            valor = empleado.password;
          } else if (error.code === "correo") {
            detalle = "Correo electrónico no válido.";
            campo = "correo";
            valor = empleado.correo;
          } else if (error.code === "codigo_centro_costo") {
            detalle = "El centro de costos no existe";
            campo = "codigo_centro_costo";
            valor = empleado.codigo_centro_costo;
          } else if (error.code === "_ID") {
            detalle = "No se encontró Empleado con ID.";
            campo = "ID";
            valor = empleado._ID;
          } else {
            detalle = `${error.message || "Error desconocido"}`;
          }

          messages.push({
            detalle: detalle,
            campo: campo,
            valor: valor,
            empleado: `${empleado.nombre} ${empleado.apellido}`,
          });
        });
        this.setState({
          messages: errores,
          mostrarErrores: errores.length > 0,
        });
      } else {
        (noErrors = true), this.setState({ noErrors: noErrors });
        messages.push({
          totalP: totalEmpleados,
          totalG: registrosGuardados,
          totalE: registrosConError,
        });

        secondaryApp.auth().signOut();
      }
    } catch (error) {
      messages.push({
        detalle: "No se pudieron leer los detalles",
        valor: "error",
      });
    } finally {
      this.setState({
        messages: messages,
        mostrarErrores: messages.length > 0,
        empleados: this.state.empleados,
        registrosGuardados: registrosGuardados,
        registrosConError: registrosConError,
        registrosProcesados: totalEmpleados,
        showResumen: true,
      });
    }
  };

  limpiar() {
    this.limpieza();
    this.props.toggleModal();
  }

  limpieza() {
    this.setState({
      cargando: false,
      progreso: 0,
      registrosGuardados: 0,
      registrosConError: 0,
      showResumen: false,
      empleados: [],
      messages: [],
      mostrarErrores: false,
    });
  }

  resetUpload() {
    this.setState({
      progreso: 0,
      registrosGuardados: 0,
      registrosConError: 0,
      showResumen: false,
      empleados: [],
      messages: [],
      mostrarErrores: false,
    });
  }

  render() {
    const {
      cargando,
      progreso,
      messages,
      mostrarErrores,
      showResumen,
      registrosGuardados,
      registrosConError,
      registrosProcesados,
    } = this.state;
    console.log("MENSAJES => ", messages);

    return (
      <div>
        <Modal
          isOpen={this.props.isActive}
          onRequestClose={this.props.toggleModal}
          style={customStyles}
        >
          <form onSubmit={this.handleSubmit}>
            <h3>Carga de empleados</h3>
            <hr />
            <div className="form-group d-flex align-items-center">
              <label htmlFor="archivo" className="mr-2">
                Seleccione el archivo
              </label>
              <input
                type="file"
                className="form-control w-auto"
                accept=".xls,.xlsx"
                onChange={this.handleFileUpload}
              />
              <button type="submit" className="btn btn-primary ml-2">
                Cargar
              </button>
            </div>

            <hr />
            {cargando && (
              <div>
                <progress
                  className="w-100"
                  value={progreso}
                  max="100"
                ></progress>
                <span>
                  {progreso.toFixed(2)}%
                  {showResumen && <span> de datos cargados</span>}
                </span>
              </div>
            )}

            {/* Mostrar la tabla solo cuando los errores estén listos */}
            {mostrarErrores && messages.length > 0 && registrosConError > 0 && (
              <div>
                <BootstrapTable
                  data={messages}
                  ref="table"
                  pagination={true}
                  search={true}
                  options={{
                    paginationSize: 5, // Número de páginas visibles en la paginación
                    sizePerPage: 5, // Número de elementos por página
                    sizePerPageList: [
                      { text: "5", value: 5 },
                      { text: "10", value: 10 },
                      { text: "20", value: 20 },
                    ], // Opciones de paginación
                  }}
                  hover
                >
                  <TableHeaderColumn
                    dataField="empleado"
                    isKey={true}
                    dataSort={true}
                  >
                    Empleado
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataField="detalle"
                    dataSort={true}
                    tdStyle={{ whiteSpace: "normal", wordWrap: "break-word" }}
                  >
                    Detalle del Error
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataField="campo"
                    dataSort={true}
                    tdStyle={{ whiteSpace: "normal", wordWrap: "break-word" }}
                  >
                    Campo Afectado
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataField="valor"
                    dataSort={true}
                    tdStyle={{ whiteSpace: "normal", wordWrap: "break-word" }}
                  >
                    Valor Incorrecto
                  </TableHeaderColumn>
                </BootstrapTable>
              </div>
            )}
            <hr />
            {showResumen && (
              <div className="alert alert-info mt-3">
                <strong>Resumen de carga:</strong>
                <ul>
                  <li>Total empleados procesados: {registrosProcesados}</li>
                  <li>Registros guardados con éxito:{registrosGuardados}</li>
                  <li className="text-danger">
                    Errores encontrados: {registrosConError}
                  </li>
                </ul>
              </div>
            )}

            <hr />
            <button
              type="button"
              className="btn btn-default float-right"
              onClick={this.limpiar}
            >
              Cerrar
            </button>
          </form>
        </Modal>
      </div>
    );
  }
}

export default Modal_Upload_Data;



// WEBPACK FOOTER //
// ./src/Components/carga_empleados/modal_upload_data.jsx